import { render, staticRenderFns } from "./static-categories-block.vue?vue&type=template&id=5b45e7fc&"
import script from "./static-categories-block.vue?vue&type=script&lang=js&"
export * from "./static-categories-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports